export const TEMP_MAX_GREEN_LIMIT = 700;
export const TEMP_MAX_YELLOW_LIMIT = 850;
